import * as d3 from 'd3';

// Inspiration from here: https://observablehq.com/@d3/kernel-density-estimation (?)

// Function to compute density
const kernelDensityEstimator = (kernel, X) => {
  return function(V) {
    return X.map(function(x) {
      return [x, d3.mean(V, function(v) { return kernel(x - v); })];
    });
  };
}
export default kernelDensityEstimator;
